import { createActionsHook, createContainer, createStateHook, createStore } from 'react-sweet-state';
import { actions } from './actions';
import { loadIndex } from './actions/load-index';
import { getSelectedFormStoreState } from './selectors/get-selected-form-store';
import { FormViewMode } from './types';
const FormIndexStore = createStore({
  initialState: {
    isIndexLoading: false,
    formIndex: [],
    selectedFormId: undefined,
    isInitialised: false,
    permissions: {},
    formViewMode: FormViewMode.View
  },
  actions,
  name: 'proforma-form-index-store'
});
export const useFormIndexState = createStateHook(FormIndexStore);
export const useFormIndexActions = createActionsHook(FormIndexStore);
export const useReportError = () => {
  const {
    reportError
  } = useFormIndexActions();
  return reportError;
};
export const useSelectedFormStoreState = createStateHook(FormIndexStore, {
  selector: getSelectedFormStoreState
});
export const FormIndexStoreContainer = createContainer(FormIndexStore, {
  onInit: () => async ({
    dispatch,
    setState
  }, {
    permissions
  }) => {
    setState({
      permissions
    });
    await dispatch(loadIndex());
    setState({
      // The `isInitialised` property exists to let the consumer of FormIndexStore, in proforma-jira-issue-view
      // package, know when to start fetching the default selected form.
      // This is a temporarily-ish solution, we need to think of a better way to orchestrate this relationship
      // after we have implemented a react-sweet-state IssueViewStore in proforma-jira-issue-view.
      isInitialised: true
    });
  }
});